<!-- 详情=>工单质检 -->
<template>
  <div class="manage_model_dialog main-wrap" v-loading="pageLoading">
    <div style="display: flex; justify-content: center">
      <div class="common_bg manage_top">
        <template v-if="hitsList.length">
          <el-button size="mini" v-for="item in hitsList" :key="item.ruleModelId" @click="getMsg(item)">{{ item.ruleModelName }}</el-button>
        </template>
        <template v-else> 暂无命中项 </template>
      </div>
    </div>
    <div class="common_bg manage_bottom" style="margin-top: 10px">
      <ul class="manage_bottom_ul">
        <template v-if="messagesList && messagesList.length">
          <template v-for="(list, jIndex) in messagesList">
            <li :key="jIndex">
              <!-- 处理记录 -->
              <template v-if="list.contentType === 'PROCESSING_RECORDS'">
                <div class="li-head">
                  <el-descriptions>
                    <el-descriptions-item :label="$lang('处理类型')">{{ list.processTypeName || '--' }}</el-descriptions-item>
                    <el-descriptions-item :label="$lang('处理时间')">{{ list.senderTime }}</el-descriptions-item>
                    <el-descriptions-item :label="$lang('处理人')">{{ list.senderName || '--' }}</el-descriptions-item>
                    <el-descriptions-item :label="$lang('处理机构')">{{ list.orgName || '--' }}</el-descriptions-item>
                  </el-descriptions>
                </div>
                <div class="li-content">
                  <template>
                    <span v-if="list.formatContent" v-html="list.formatContent"></span>
                    <span v-else-if="list.content">{{ list.content }}</span>
                    <span v-else>--</span>
                  </template>
                  <el-descriptions v-if="list.paths && list.paths.length">
                    <el-descriptions-item :label="$lang('附件')">
                      <span v-if="list.paths && list.paths.length" class="link-color pointer-view" @click="showAllDiglog(list.paths)"
                        >{{ $lang('查看附件') }}({{ list.paths.length }})</span
                      >
                    </el-descriptions-item>
                  </el-descriptions>
                </div>
              </template>
              <!-- 263通话记录 -->
              <template v-if="list.contentType === 'CALL_RECORDS'">
                <div class="li-head">
                  <el-descriptions>
                    <el-descriptions-item :label="$lang('处理类型')">{{ list.processTypeName || '--' }}</el-descriptions-item>
                    <el-descriptions-item :label="$lang('通话开始时间')">{{ list.senderTime || '--' }}</el-descriptions-item>
                    <el-descriptions-item :label="$lang('外呼网点名称')">{{ list.orgName || '--' }}</el-descriptions-item>
                    <el-descriptions-item :label="$lang('通话状态')">{{ getCallState(list) || '--' }}</el-descriptions-item>
                  </el-descriptions>
                </div>
                <div class="li-content">
                  <avue-crud :data="getContentList(list)" :option="listOpt"> </avue-crud>
                </div>
              </template>
              <!-- 短信记录 -->
              <template v-if="list.contentType === 'SMS_RECORDS'">
                <div class="li-head">
                  <el-descriptions>
                    <el-descriptions-item :label="$lang('处理类型')">{{ list.processTypeName || '--' }}</el-descriptions-item>
                    <el-descriptions-item :label="$lang('发送时间')">{{ list.senderTime || '--' }}</el-descriptions-item>
                    <el-descriptions-item :label="$lang('发送结果')">{{ list.senderResult || '--' }}</el-descriptions-item>
                    <el-descriptions-item :label="$lang('用户名称')">{{ list.senderName || '--' }}</el-descriptions-item>
                    <el-descriptions-item :label="$lang('网点名称')">{{ list.orgName || '--' }}</el-descriptions-item>
                    <el-descriptions-item :label="$lang('客户手机号')">{{ list.phone || '--' }}</el-descriptions-item>
                  </el-descriptions>
                </div>
                <div class="li-content">
                  <el-descriptions>
                    <el-descriptions-item :label="$lang('短信内容')">{{ list.content || '--' }}</el-descriptions-item>
                  </el-descriptions>
                </div>
              </template>
            </li>
          </template>
        </template>
        <div class="no-data" v-else>
          {{ $lang('暂无数据') }}
        </div>
      </ul>
    </div>
    <!-- 附件预览 -->
    <BaseAnnexView :visible.sync="annexDialogVisible" :fileListResAll="fileListResAll" />
  </div>
</template>

<script>
import { modelGroupApi } from './pool'
import { RESPONSE_CODE } from '@public/http/config'
import BaseAnnexView from '@/components/base/BaseAnnexView'
import { Descriptions, DescriptionsItem } from 'element-ui'
import viewMixin from './_mixins/viewMixin'
export default {
  name: 'ModelWorkOrder',
  components: {
    BaseAnnexView,
    'el-descriptions': Descriptions,
    'el-descriptions-item': DescriptionsItem
  },
  mixins: [viewMixin],
  data() {
    return {
      COM_HTTP: modelGroupApi,
      hitsList: [], // 命中关键字
      messagesList: [], // 对话
      pageLoading: true,
      annexDialogVisible: false,
      fileListResAll: []
    }
  },
  watch: {
    '$route.query.taskId': {
      handler(newVal, oldVal) {
        if (newVal) {
          this.getView()
        }
      },
      deep: true
    },
    '$route.params.id': {
      handler(newVal, oldVal) {
        if (newVal && oldVal && newVal !== oldVal) {
          this.getView()
        }
      },
      deep: true
    }
  },
  created() {
    this.getView()
  },
  methods: {
    // 预览附件
    showAllDiglog(paths) {
      this.fileListResAll = paths
      this.annexDialogVisible = true
    },
    // 获取语音对话内容
    async getView() {
      let taskId = null
      const extRuleModel = null
      taskId = this.$route.params.id
      if (!taskId) return
      this.pageLoading = true
      const { code, data, msg } = await this.COM_HTTP.reqView({ id: taskId, extRuleModel })
      if (code === RESPONSE_CODE.SUCCESS) {
        this.pageLoading = false
        const { sessionMessages, detects } = data
        const detect = detects.filter((o) => {
          return o.type === 'PREVIEW' || o.type === 'CP_RECHECKED'
        })
        const hits = []
        detect.map((res) => {
          hits.unshift(...res.hits)
        })
        this.setTextHighlight(hits, sessionMessages)
        this.hitsList = hits || []
        const dimensionsArr = hits.reduce((preHit, currHit) => {
          return [...preHit, ...(currHit.dimensions || [])]
        }, [])
        // 模型命中标记
        dimensionsArr?.forEach((res) => {
          const bFindIndex = sessionMessages?.findIndex((item) => item?.globalIndexBegin === res?.index)
          const eFindIndex = sessionMessages?.findIndex((item) => item?.globalIndexEnd === res?.index)
          let setIndex = null
          if (bFindIndex > -1) {
            setIndex = bFindIndex
          }
          if (eFindIndex > -1) {
            setIndex = eFindIndex + 1
          }
          if (setIndex || setIndex === 0) {
            res.senderRole = 'desc'
            sessionMessages?.splice(setIndex, 0, res)
          }
        })
        // 添加静默时间
        const silenceTimeArr = [...sessionMessages]
        silenceTimeArr.forEach((itemTIme) => {
          if (itemTIme?.silenceTimeDesc) {
            // 如果上面有静默时长,不需要添加
            let setIndex = sessionMessages?.findIndex((item) => item?.id === itemTIme?.id)
            if (setIndex !== 0 && sessionMessages[setIndex - 1].senderRole === 'desc') {
              setIndex = null
            }
            const setItem = {
              senderRole: 'silenceTime',
              silenceTimeDesc: itemTIme.silenceTimeDesc
            }
            if (setIndex) {
              sessionMessages?.splice(setIndex, 0, setItem)
            }
          }
        })
        // 工单质检,只展示工单数据
        const setWorkOrderList = sessionMessages.filter((res) => {
          return ['PROCESSING_RECORDS', 'CALL_RECORDS', 'SMS_RECORDS'].includes(res.contentType)
        })
        this.messagesList = setWorkOrderList || []
      } else {
        this.$message.error(msg)
        this.pageLoading = false
      }
    },
    getContentList(list) {
      const obj = list?.content || ''
      return obj ? [JSON.parse(obj)] : []
    },
    // 通话状态
    getCallState(list) {
      const obj = list?.content || ''
      const item = obj ? JSON.parse(obj) : ''
      return item ? item.woCallRecordState : ''
    }
  },
  computed: {
    listOpt() {
      return {
        addBtn: false,
        search: false,
        customAdd: false,
        customEdit: false,
        customView: false,
        selection: false,
        menu: false,
        maxHeight: 90,
        index: false,
        column: [
          {
            label: '通话结束时间',
            prop: 'woCallEndAt'
          },
          {
            label: '主叫号码',
            prop: 'woCallCaller'
          },
          {
            label: '被叫号码',
            prop: 'woCallCallee'
          },
          {
            label: '挂机原因',
            prop: 'woCallHangupCause'
          },
          {
            label: '挂断方',
            prop: 'woCallHangupParty'
          },
          {
            label: '未接通原因',
            prop: 'woCallDa2Result'
          },
          {
            label: '实际通话时长',
            prop: 'woCallDuration'
          }
        ]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.manage_model_dialog {
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .manage_top {
    text-align: center;
    display: flex;
    overflow-x: auto;
    justify-content: center;
  }
  .common_bg {
    width: 100%;
    border: 1px solid #ccc;
    box-sizing: border-box;
    padding: 15px;
    border-radius: 10px;
  }
  .manage_bottom {
    overflow-y: auto;
    .manage_bottom_ul {
      padding: 0px;
      .no-data {
        text-align: center;
      }
      li {
        display: block;
        border: 1px solid #ccc;
        border-radius: 5px;
        margin-bottom: 20px;
        .li-head {
          padding: 10px 10px 0px 10px;
          border-bottom: 1px solid #ccc;
          ::v-deep .el-descriptions-item {
            display: inline-block;
            margin: 0px 30px 10px 0px;
          }
          ::v-deep .el-descriptions__body{
            // @include bg-color('main');
            // @include text-color('subtitle');
          }
        }
        .li-content {
          padding: 10px;
        }
      }
    }
  }
}
</style>
